/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-16 14:22:32
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-10 14:47:32
 * @name: 工单服务
 * @Description: 工单服务
 * @FilePath: \project\src\module\issue\issue.service.js
 * @Author: desktop
 */
import issueController from "./issue.controller";
import { afterSale_acts, afterSale_successStatus } from "@/config/afterSale.config.js";
import issueConfig from "@/config/issue.config.js";
import router from "@/router";
const issueService = class {
  constructor() {
    this.issueController = new issueController();
    this.afterSale_acts = afterSale_acts;
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取售后列表
   * @param {Object} req 传参 
   */
  issueGetList(req) {
    return new Promise((resolve, reject) => {
      this.issueController.getList(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取售后待审批列表
   * @param {Object} req 传参 
   */
  issueGetNeedVerifyList(req) {
    return new Promise((resolve, reject) => {
      this.issueController.getNeedVerifyList(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取售后待确认列表
   * @param {Object} req 传参 
   */
  issueGetEnsureList(req) {
    return new Promise((resolve, reject) => {
      this.issueController.getEnsureList(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取售后待处理列表
   * @param {Object} req 传参 
   */
  issueGetTodoList(req) {
    return new Promise((resolve, reject) => {
      this.issueController.getTodoList(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取状态文字
   * @param {Object} e 工单数据
   */
  getStatusText(e) {
    let statusText = '待审批';
    if (e.process_type === 'repeat_send') {
      statusText = '已抄送';
    } else if (Number(e.status) === 80) {
      statusText = '已完成';
    } else if (Number(e.status) === 15) {
      statusText = '已废单';
    } else if (Number(e.status) === 5 || Number(e.status) === 0) {
      statusText = '失败';
    } else if (Number(e.run_status) !== 0) {
      statusText = afterSale_successStatus.find(x => x.value?.includes(e.run_act))?.text ?? '已处理';
    } else if (this.afterSale_acts.findIndex(x => e.run_act === x.key) > -1) {
      statusText = this.afterSale_acts.find(x => e.run_act === x.key).statusText;
    } else {
      statusText = '待审批';
    }
    return statusText;
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 跳转详情
   * @param {String} module 模块 
   * @param {Object} row  工单数据
   */
  pushToDetail(module, row) {
    let query = {
      issue_id: row.id,
      run_process_id: row.run_process_id,
      run_id: row.run_id,
      run_status: row.run_status,
      run_act: row.run_act,
    };
    let path = module;
    // 已完成,查看评价
    if (Number(row.status) === 80) {
      path = path + '/waitApproveDeal';
    }
    // 不是自己的处理步骤
    else if (Number(row.run_status) !== 0) {
      path = path + '/waitApproveDeal';
    }
    // act特殊处理
    else if (this.afterSale_acts.findIndex(x => row.run_act === x.key) > -1) {
      path = path + this.afterSale_acts.find(x => row.run_act === x.key).path;
    }
    // 审批
    else {
      path = path + '/waitApproveDeal';
    }
    router.push({
      path,
      query,
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取工单详情
   */
  getVeifyQuality(req) {
    return new Promise((resolve, reject) => {
      this.issueController.getVeifyQuality(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 通用审批
   * @param {Object} req 参数
   */
  doApprove(req) {
    return new Promise((resolve, reject) => {
      this.issueController.doApprove(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 默认内部收件人
   * @param {Object} req 参数
   */
  getDefaultAddress(req) {
    return new Promise((resolve, reject) => {
      this.issueController.getDefaultAddress(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 提交售后解决方案
   * @param {Object} req 参数
   */
  setPlan(req) {
    return new Promise((resolve, reject) => {
      //未传need_qa_check，赋默认值0.
      !req.need_qa_check && (req.need_qa_check = 0);
      this.issueController.setPlan(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取工单配置数据
   * @param {String} e 匹配项
   * @param {String} v 匹配值
   * @return {String} label值 文字
   */
  getIssueConfigText(e, v) {
    return issueConfig[e]?.find(x => x.value === Number(v))?.label ?? '';
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 判断可否编辑
   * @param {String} run_act 操作
   */
  checkCanEdit(run_act) {
    return ['xuyingxiaozhuren', 'yingxiaozhurenshenpi'].includes(run_act);
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 修改处理方案
   */
  editDealScheme(req) {
    return new Promise((resolve, reject) => {
      //未传need_qa_check，赋默认值0.
      !req.need_qa_check && (req.need_qa_check = 0);
      this.issueController.edit(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 售后经理审批(选择是否需要营销中心主任审批)
   * @param {Object} req 参数
   */
  saleServiceManagerVerify(req) {
    return new Promise((resolve, reject) => {
      this.issueController.saleServiceManagerVerify(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 品质审批(上传评审结果图片)
   * @param {Object} req 参数
   */
  qualityVerify(req) {
    return new Promise((resolve, reject) => {
      this.issueController.qualityVerify(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 定价(售后)
   * @param {Object} req 参数
   */
  issueFee(req) {
    return new Promise((resolve, reject) => {
      this.issueController.issueFee(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 售后经理审批（选择是否需要营销主任审批）
   * @param {Object} req 参数
   */
  saleServiceManagerVerify(req) {
    return new Promise((resolve, reject) => {
      this.issueController.saleServiceManagerVerify(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 售后经理审批(选择是否需要销售副总审批)
   * @param {Object} req 参数
   */
  saleManagerVerify(req) {
    return new Promise((resolve, reject) => {
      this.issueController.saleManagerVerify(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 确认缴费
   * @param {Object} req 参数
   */
  confirmFee(req) {
    return new Promise((resolve, reject) => {
      this.issueController.confirmFee(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取快递公司名称
   * @param {Object} req 参数 {com: 快递公司代号}
   */
  getCompanyName(req) {
    return new Promise((resolve, reject) => {
      this.issueController.getPackageCompanyList({ name: '' }).then((ctx) => {
        resolve({ item: ctx.response.data?.[req?.com ?? '']?.company_name ?? '', items: ctx.response.data });
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取物流信息列表
   * @param {Object} req 参数
   */
  getPackageInfo(req) {
    return new Promise((resolve, reject) => {
      this.issueController.getPackageInfo(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 确认收货
   * @param {Object} req 参数
   */
  confirmParts(req) {
    return new Promise((resolve, reject) => {
      this.issueController.confirmParts(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取发件人记录
   * @param {Object} req 参数
   */
  getReplacementPartsUser(req) {
    return new Promise((resolve, reject) => {
      this.issueController.getReplacementPartsUser(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取上门人记录
   * @param {Object} req 参数
   */
  getLastHomeServiceUser(req) {
    return new Promise((resolve, reject) => {
      this.issueController.getLastHomeServiceUser(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 安排发件人
   * @param {Object} req 参数
   */
  replacementParts(req) {
    return new Promise((resolve, reject) => {
      this.issueController.replacementParts(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 填写物流信息
   * @param {Object} req 参数
   */
  addTransport(req) {
    return new Promise((resolve, reject) => {
      this.issueController.addTransport(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 安排上门人
   * @param {Object} req 参数
   */
  homeService(req) {
    return new Promise((resolve, reject) => {
      this.issueController.homeService(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 填写售后服务单
   * @param {Object} req 参数
   */
  addServiceIssue(req) {
    return new Promise((resolve, reject) => {
      this.issueController.addServiceIssue(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 废单
   * @param {Object} req 参数
   */
  endFlow(req) {
    return new Promise((resolve, reject) => {
      this.issueController.endFlow(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 流程信息处理
   * @param {Array} run_process 流程信息 
   */
  dealRunProcess(run_process) {
    return Object.values(run_process);
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 打印列表
   */
  issuePrint(req) {
    return new Promise((resolve, reject) => {
      this.issueController.issuePrint(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 销售副总审批
   */
  secondBoss(req) {
    return new Promise((resolve, reject) => {
      this.issueController.secondBoss(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 更新费用
   */
  editFee(req) {
    return new Promise((resolve, reject) => {
      this.issueController.editFee(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 根据琴号查询ERP产品id相关信息
   */
  getPianoInfo(req) {
    return new Promise((resolve, reject) => {
      this.issueController.getPianoInfo(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 按型号获取ERP产品列表
   */
  getPianoModels(req) {
    return new Promise((resolve, reject) => {
      this.issueController.getPianoModels(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
  /**
  * @Auther: 罗耀祖
  * @LastEditors: 罗耀祖
  * @description: 修改钢琴型号和颜色
  */
  editIssue(req) {
    return new Promise((resolve, reject) => {
      this.issueController.editIssue(req).then((ctx) => {
        resolve(ctx.response);
      }).catch((ctx) => {
        reject(ctx.response);
      });
    })
  }
}
export default issueService;